"use client"

import { useState, Suspense, useEffect } from "react"
import { usePathname } from "next/navigation"
import { Sidebar } from "@/components/sidebar"
import { cn } from "@/lib/utils"
import { DashboardHeader } from "./DashboardHeader"

export function DashboardShell({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsed] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    const handleSetCollapsed = (e: Event) => {
      const customEvent = e as CustomEvent<boolean>
      setCollapsed(customEvent.detail)
    }
    window.addEventListener("set-sidebar-collapsed", handleSetCollapsed)
    return () => {
      window.removeEventListener("set-sidebar-collapsed", handleSetCollapsed)
    }
  }, [])

  const isTemplateEditor =
    pathname === "/templates/new" ||
    /^\/templates\/[^/]+\/edit$/.test(pathname!);

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-950 transition-colors overflow-hidden">
      <Sidebar
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((c) => !c)}
      />

      <div
        className={cn(
          "flex flex-col flex-1 transition-all duration-200",
          collapsed ? "ml-16" : "ml-48"
        )}
      >
        <Suspense
          fallback={
            <div className="h-16 border-b bg-white dark:bg-gray-900 shadow-sm" />
          }
        >
          <DashboardHeader />
        </Suspense>

        <main
          className={cn(
            "flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-950 transition-colors",
            !isTemplateEditor && "p-6"
          )}
        >
          {children}
        </main>
      </div>
    </div>
  )
}